import { actions } from '../constants/survey';
import * as actionTypes from '../../models/action/survey';
import { IAction } from '../../models/action/core';
import { IUserResponses } from '../../models/components/activity-card-survey';
import * as types from '../../models/pages/survey';
import { SurveyType } from '../../models/enums/SurveyType';
import { SecurityContextType } from '../../core/SecurityContext';

// #region Add Survey Action
export function addSurveyGetAction(surveyData: actionTypes.ISurveyData, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void): actionTypes.IGetAddSurvey {
    return {
        surveyData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_SURVEY_ACTIVITY,
        callback
    };
}

// Add Survey Update Get Action
export function updateSurveyGetAction(
    dataParams: actionTypes.IUpdateSurveyParams,
    spinnerId: string,
    spinnerType: 'get'|'set'
): actionTypes.IUpdateSurveyGet {
    return {
        ...dataParams,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_SURVEY_UPDATE_ACTIVITY
    };
}

export function addSurveySetAction(surveyData: actionTypes.ISurveyData[] | null, addSurveyStatus: boolean, spinnerId?: string, spinnerType?:'get'|'set'): actionTypes.ISetAddSurvey {
    return {
        surveyData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_SURVEY_SET_ACTIVITY
    };
}

export function setSurveyDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_SURVEY_DATA_DEFAULT
    };
}
// #endregion Add Survey Action


// #region Add Survey Action
export function deleteSurveyGetAction(
    data: actionTypes.DeleteData
): actionTypes.IGetDeleteSurvey {
    return {
        surveyData: data,
        timestamp: Date.now(),
        type: actions.DELETE_SURVEY_ACTIVITY
    };
}

export function deleteSurveySetAction(deleteSurveyStatus: boolean): actionTypes.ISetDeleteSurvey {
    return {
        deleteSurveyStatus,
        timestamp: Date.now(),
        type: actions.DELETE_SURVEY_SET_ACTIVITY
    };
}

export function getEditSurveyInfo(surveyData: actionTypes.ISurveyData, surveyInfo: actionTypes.ISurveyInfo, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void): actionTypes.IGetEditSurveyInfo {
    return {
        surveyData,
        surveyInfo,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EDIT_SURVEY_INFO,
        callback
    };
}

export function responseSurvey(responses: IUserResponses[], surveyInfoId: string, contextType: SecurityContextType, contextId: string, activityId: string, classId: string, enrollmentId: string, surveyType: SurveyType, callback?: (value: boolean) => void,questionLength?:number, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IResponseSurvey {
    return {
        responses,
        surveyInfoId,
        contextType,
        contextId,
        activityId,
        classId,
        enrollmentId,
        surveyType,
        callback,
        questionLength,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.RESPONSE_SURVEY,
    };
}

export function GetLoginSurveyById(params: any, spinnerId?: string, spinnerType?: 'get' | 'set') : actionTypes.ILoginSurveyByIdGetAction {
    return{
        params,
        timestamp: Date.now(),
        type: actions.GET_SELECTED_LOGIN_SURVEY,
        spinnerId,
        spinnerType
    };
}

export function SetLoginSurveyByIdAction(
    selectedSurvey: any,
    selectedSurveyIsLoaded: boolean,
    spinnerId?: string,
    spinnerType?: 'get'|'set'
): actionTypes.ISelectedSurveySetAction {
    return {
        selectedSurvey,
        selectedSurveyIsLoaded,
        timestamp: Date.now(),
        type: actions.SET_SELECTED_LOGIN_SURVEY,
        spinnerId,
        spinnerType
    };
}

export function getSurveysAction(gStateId: string, spinnerId?: string, spinnerType?: 'get'|'set', take?: number, skip?: number, callback?: any, searchedWord?: string, isHomePageSurvey?: boolean, isShowOnStartup?: boolean, lastActivityId?: string,isHompageBox?: boolean): actionTypes.ISurveysGetAction {
    return {
        timestamp: Date.now(),
        spinnerId,
        spinnerType,
        stateId: gStateId,
        take,
        skip,
        type: actions.GET_SURVEY_LIST,
        callback,
        searchedWord,
        isHomePageSurvey,
        isShowOnStartup,
        lastActivityId,
        isHompageBox
    };
}

export function setSurveysAction(
    surveys: any[],
    surveyIsLoaded: boolean,
    stateId: string, spinnerId?: string, spinnerType?: 'get'|'set',
    take?: number,
    skip?: number,
    isHomePageSurvey?: boolean,
    lastActivityId?: string
): actionTypes.ISurveysSetAction {
    return {
        surveyIsLoaded,
        spinnerId,
        spinnerType,
        surveys,
        stateId,
        timestamp: Date.now(),
        type: actions.SET_SURVEY_LIST,
        take,
        skip,
        isHomePageSurvey,
        lastActivityId
    };
}

export function GetGeneralSurveyById(params: any, spinnerId?: string, spinnerType?: 'get' | 'set') : actionTypes.ILoginSurveyByIdGetAction {
    return{
        params,
        timestamp: Date.now(),
        type: actions.GET_SELECTED_GENERAL_SURVEY,
        spinnerId,
        spinnerType
    };
}

export function SetGeneralSurveyByIdAction(
    selectedSurvey: any,
    selectedSurveyIsLoaded: boolean,
    spinnerId?: string,
    spinnerType?: 'get'|'set'
): actionTypes.ISelectedSurveySetAction {
    return {
        selectedSurvey,
        selectedSurveyIsLoaded,
        timestamp: Date.now(),
        type: actions.SET_SELECTED_GENERAL_SURVEY,
        spinnerId,
        spinnerType
    };
}